import Header from "./Header";
import Concerts from "./Concerts";
import Projects from "./Projects";
import Footer from "./Footer";

function Home() {

  return (
    <div className="main">
      <Header />
      <Concerts />
      <Projects />
      <Footer />
    </div>
  );
}

export default Home;
